import React from 'react';
import Card from "../../../components/card";
import "../css/pend-table.css"
import InputForm from "../../../components/input-form";
import SelectComponent from "../../../components/select-component";
import InputDateTime from "../../../components/input-datetime";

const PendTable = ({state, setState, ordersId}) => {
    const multiway_solution = state.pend_multiway_id_solution ? {label: state.pend_multiway_id_solution, value: state.pend_multiway_id_solution} : null
    const client_solution = state.pend_client_id_solution ? {label: state.pend_client_id_solution, value: state.pend_client_id_solution} : null
    const terceiros_solution = state.pend_terceiros_id_solution ? {label: state.pend_terceiros_id_solution, value: state.pend_terceiros_id_solution} : null

    const handleInput = ({target: {id, value}}) => setState(prev => ({...prev, [id]: value}));

    const handleCheckbox = ({target: {id, checked}}) => {
        setState(prev => {
            if (!checked) {
                prev[id + "_id_solution"] = "";
                prev[id + "_desc"] = "";
                prev[id + "_dt"] = "";

                return {...prev, [id]: checked, [id + "_id_solution"]: "", [id + "_desc"]: "", [id + "_dt"]: ""};
            }

            return {...prev, [id]: checked};
        })
    };

    const handleCustomInput = (id, value) => setState(prev => ({...prev, [id]: value?.value ?? value ?? ""}));
    return (
        <Card title="Pendências" wrapperClass="mt-5">
            <table id="pend-table">
                <thead>
                    <tr>
                        <th style={{width: "10%"}}>Pendência</th>
                        <th style={{width: "45%"}}>Descrição</th>
                        <th style={{width: "15%"}}>OS Solução</th>
                        <th style={{width: "20%"}}>Solução</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input type="checkbox" id="pend_multiway" checked={state.pend_multiway} onChange={handleCheckbox}
                                   className="text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-0 cursor-pointer"/>
                            <label htmlFor="pend_multiway" className="ml-2 text-gray-700 cursor-pointer select-none">
                                Multiway
                            </label>
                        </td>
                        <td>
                            <InputForm id="pend_multiway_desc" value={state.pend_multiway_desc ?? ""}
                                       onChange={handleInput} disabled={!state.pend_multiway}/>
                        </td>
                        <td>
                            <SelectComponent
                                instanceId="pend_multiway_id_solution"
                                options={ordersId}
                                value={multiway_solution}
                                onChange={(value) => handleCustomInput("pend_multiway_id_solution", value)}
                                isDisabled={!state.pend_multiway}
                            />
                        </td>
                        <td>
                            <InputDateTime id="pend_multiway_dt" onChange={(date) => handleCustomInput("pend_multiway_dt", date)} selected={state.pend_multiway_dt} disabled={!state.pend_multiway} showTime/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="pend_client" checked={state.pend_client} onChange={handleCheckbox}
                                   className="text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-0 cursor-pointer"/>
                            <label htmlFor="pend_client" className="ml-2 text-gray-700 cursor-pointer select-none">
                                Cliente
                            </label>
                        </td>
                        <td>
                            <InputForm id="pend_client_desc" value={state.pend_client_desc ?? ""} onChange={handleInput} disabled={!state.pend_client}/>
                        </td>
                        <td>
                            <SelectComponent
                                instanceId="pend_client_id_solution"
                                options={ordersId}
                                value={client_solution}
                                onChange={(value) => handleCustomInput("pend_client_id_solution", value)}
                                isDisabled={!state.pend_client}
                            />
                        </td>
                        <td>
                            <InputDateTime id="pend_client_dt" onChange={(date) => handleCustomInput("pend_client_dt", date)} selected={state.pend_client_dt} disabled={!state.pend_client} showTime/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="pend_terceiros" checked={state.pend_terceiros} onChange={handleCheckbox}
                                   className="text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-0 cursor-pointer"/>
                            <label htmlFor="pend_terceiros" className="ml-2 text-gray-700 cursor-pointer select-none">
                                Multiway subcontratado
                            </label>
                        </td>
                        <td>
                            <InputForm id="pend_terceiros_desc" value={state.pend_terceiros_desc ?? ""} onChange={handleInput} disabled={!state.pend_terceiros}/>
                        </td>
                        <td>
                            <SelectComponent
                                instanceId="pend_terceiros_id_solution"
                                options={ordersId}
                                value={terceiros_solution}
                                onChange={(value) => handleCustomInput("pend_terceiros_id_solution", value)}
                                isDisabled={!state.pend_terceiros}
                            />
                        </td>
                        <td>
                            <InputDateTime id="pend_terceiros_dt" onChange={(date) => handleCustomInput("pend_terceiros_dt", date)} selected={state.pend_terceiros_dt} disabled={!state.pend_terceiros} showTime/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </Card>
    );
};

export default PendTable;